import PropTypes from 'prop-types'
import React from 'react'

import { Box, Button as MUIButton } from '@material-ui/core'
import { Button, Text, Loading } from '@xti-external/frontend-kit-components'
import { Field, Form, Formik } from 'formik'
import { kebabCase } from 'lodash-es'

import CustomCheckbox from '~/components/CustomCheckbox'
import CustomTextField from '~/components/CustomTextField'
import { currentSubDomain } from '~/config/constants'
import { SCREEN_TYPE } from '~/config/screen'
import useCustom from '~/pages/Login/hooks'
import loginSchema from '~/pages/Login/schema'

import useStyle from './style'

const LoginDesktop = ({ ssoLinks }) => {
  const { handler } = useCustom({ screen: SCREEN_TYPE.DESKTOP })
  const classes = useStyle()
  const renderButtonSSO = (isSubmitting) => {
    if (ssoLinks.length > 0) {
      return ssoLinks.map((data) => (
        <Button
          disabled={isSubmitting}
          data-testid="microsoft-login-btn"
          href={data?.link}
          target="_self"
          text={`Login with ${data?.name}`}
          size="lg"
          startIcon={
            <img
              src={`/public/icons/${kebabCase(data?.name)}-icon.svg`}
              alt={`${kebabCase(data?.name)}-icon`}
              height="30px"
              width="30px"
            />
          }
          width="100%"
          variant="secondary"
          key={`${kebabCase(data?.name)}-button`}
        />
      ))
    }
    return <Loading />
  }

  return (
    <Box display="flex" height="100%" flex={1} className={classes.container}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flex={1}
        ml={8}
      >
        <Box
          display="flex"
          height="100%"
          flexDirection="column"
          justifyContent="center"
          className={classes.formWrapper}
        >
          {currentSubDomain !== 'xl-idm' &&
            currentSubDomain !== 'localhost' && (
              <img
                className={classes.logo}
                src="/public/images/xapiens-logo-black.svg"
                alt="landing"
              />
            )}

          <Text component="div" size="md" variant="paragraph" bold>
            Login to Your Account
          </Text>
          <Box mb={5}>
            <Text component="span" size="sm" variant="paragraph">
              one account for ThingsBox, AnalytiX, and more
            </Text>
          </Box>
          <Formik
            initialValues={{
              username: '',
              password: '',
              keepSignIn: false,
            }}
            validationSchema={loginSchema}
            onSubmit={handler.handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <Box
                  display="flex"
                  flexDirection="column"
                  className={classes.formSection}
                  mt={8}
                >
                  <Field
                    component={CustomTextField}
                    label="Username/Email"
                    labelPosition="vertical"
                    name="username"
                    placeholder="Username/Email"
                    size="lg"
                    width="100%"
                  />
                  <Field
                    component={CustomTextField}
                    label="Password"
                    labelPosition="vertical"
                    name="password"
                    placeholder="Password"
                    size="lg"
                    width="100%"
                    type="password"
                  />
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={6}
                    className={classes.checkBoxWrapper}
                  >
                    <Field
                      name="keepSignIn"
                      type="checkbox"
                      as={CustomCheckbox}
                      label={
                        <Text component="span" size="xs" variant="paragraph">
                          Keep me signed in
                        </Text>
                      }
                    />
                    <Box display="flex" justifyContent="flex-end">
                      <MUIButton
                        className={classes.forgotPassword}
                        onClick={handler.handleForget}
                        data-testid="forgot-password-btn"
                      >
                        <Text component="span" size="xs" variant="paragraph">
                          Forgot Password?
                        </Text>
                      </MUIButton>
                    </Box>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="column"
                    className={classes.buttonWrapper}
                  >
                    <Button
                      disabled={isSubmitting}
                      data-testid="login-btn"
                      type="submit"
                      text="Login"
                      size="lg"
                      width="100%"
                    />
                    {renderButtonSSO(isSubmitting)}
                  </Box>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flex={1}
        className={classes.background}
      />
    </Box>
  )
}

LoginDesktop.defaultProps = {
  ssoLinks: [],
}

LoginDesktop.propTypes = {
  ssoLinks: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      link: PropTypes.string,
    }),
  ),
}

export default LoginDesktop
